export default "__VITE_ASSET__DBlrKfpL__"